<template>
  <VueFragment>
    <div class="header">
      <h1>JAMES CHOI</h1>
    </div>

    <SectionRowContainer>
      <b-col md="3">
        <ResumeInfoSnippetSection
          v-for="info in personalResumeDescriptions"
          :key="info.title"
          :info="info"
        />
      </b-col>

      <b-col md="1"></b-col>

      <b-col md="8">
        <ResumeDescriptionSection
          :infos="workExperienceDescriptions"
          sectionTitle="WORK EXPERIENCE"
        />

        <ResumeDescriptionSection
          :infos="projectDescriptions"
          sectionTitle="PROJECTS"
        />
      </b-col>
    </SectionRowContainer>
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

import ResumeInfoSnippetSection from '../components/ResumeInfoSnippetSection.vue';
import ResumeDescriptionSection from '../components/ResumeDescriptionSection.vue';
import SectionRowContainer from '../components/layout/SectionRowContainer.vue';

import personalResumeDescriptions from '../assets/data/personal-resume-descriptions.json';
import projectDescriptions from '../assets/data/project-descriptions.json';
import workExperienceDescriptions from '../assets/data/work-experience-descriptions.json';

export default {
  name: 'ResumePage',
  components: {
    ResumeDescriptionSection,
    ResumeInfoSnippetSection,
    SectionRowContainer,
    VueFragment
  },
  data() {
    return {
      personalResumeDescriptions,
      projectDescriptions,
      workExperienceDescriptions
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background-color: $darkBlue;
  padding: 30px 15px;

  h1 {
    font-size: 70px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    margin: 0;
  }
}

@media (max-width: $mediaMdWidth) {
  .right-column {
    margin-top: -20px;
  }
}
</style>
